import { Avatar, AvatarGroup, Box, Tooltip } from '@mui/material';
import {
  normalizeSupportInterestedUser,
  supportUserAvatarColor,
  supportUserInitials,
} from '../utils/supportUserDisplay';
import { colorTokens } from '../app/designTokens';

const { semantic } = colorTokens;
const MAX_VISIBLE = 5;

/**
 * Avatar group for interested users / watchers (MafertApp InvolvedUsers behavior).
 */
export function SupportInterestedUsersAvatars({
  users = [],
  max = MAX_VISIBLE,
  size = 32,
  emptyLabel,
}) {
  const normalized = (Array.isArray(users) ? users : [])
    .map(normalizeSupportInterestedUser)
    .filter((u) => u.id != null || u.name);

  if (normalized.length === 0) {
    return emptyLabel ? (
      <Box component="span" sx={{ color: semantic.text.muted, fontSize: 13 }}>
        {emptyLabel}
      </Box>
    ) : null;
  }

  const visible = normalized.slice(0, max);
  const overflow = normalized.length - visible.length;

  return (
    <AvatarGroup
      max={max + (overflow > 0 ? 1 : 0)}
      data-testid="interested-users-avatars"
      sx={{
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
        '& .MuiAvatar-root': {
          width: size,
          height: size,
          fontSize: size * 0.35,
          border: `2px solid ${semantic.bg.surface}`,
        },
      }}
    >
      {visible.map((user) => {
        const title = user.name || user.email || String(user.id);
        const initials = supportUserInitials(user.name || user.email);
        const bg = supportUserAvatarColor(user.email || user.name || user.id);
        return (
          <Tooltip key={String(user.id ?? title)} title={title}>
            <Avatar
              alt={title}
              src={user.avatarUrl || undefined}
              aria-label={title}
              sx={{ bgcolor: user.avatarUrl ? undefined : bg, color: '#fff' }}
            >
              {!user.avatarUrl ? initials : null}
            </Avatar>
          </Tooltip>
        );
      })}
      {overflow > 0 ? (
        <Tooltip title={normalized.slice(max).map((u) => u.name || u.email).filter(Boolean).join(', ')}>
          <Avatar
            sx={{ bgcolor: semantic.bg.surfaceSelected, color: semantic.text.primary, fontSize: size * 0.32 }}
            aria-label={`+${overflow}`}
          >
            {`+${overflow}`}
          </Avatar>
        </Tooltip>
      ) : null}
    </AvatarGroup>
  );
}
